// React
import React from 'react';
// External
import { Col, Row } from 'react-bootstrap';
// Style
import './styles.scss';

function EngravingImages(props) {
    return (
        <div>
            <Row className="only-visible-on-lg-and-above">
                <Col lg={8} style={{ display: 'inline-block' }}>&nbsp;</Col>
                <Col lg={4} style={{ display: 'inline-block' }}>
                    <div
                        className="section-description"
                        style={{
                            textAlign: 'center',
                            marginBottom: '5px'
                        }}
                    >
                        Example Only
                    </div>
                </Col>
            </Row>
            <Row>
                <Col lg={4} className="col-12" style={{ textAlign: 'center' }}>
                    {props.engraving && (
                        <img
                            src={props.engraving}
                            alt="Saved Engraving"
                            style={{ width: '100%' }}
                            className="engraving-approval-img"
                        />
                    )}
                </Col>
                <Col lg={4} className="col-12" style={{ textAlign: 'center' }}>
                    <p className="only-visible-on-below-lg" style={{ height: '20px' }} />
                    {props.savedImage && (
                        <img
                            src={props.savedImage}
                            alt="Saved"
                            className="engraving-approval-img"
                            style={{ width: '100%' }}
                        />
                    )}
                </Col>
                <Col
                    lg={4}
                    style={{ textAlign: 'center' }}
                    className="col-12 vessel-img-container"
                >
                    <p
                        className="only-visible-on-below-lg"
                        style={{
                            verticalAlign: 'bottom',
                            lineHeight: '0',
                            paddingTop: '30px'
                        }}
                    >
                        Example Only
                    </p>

                    <img
                        src={props.vesselImage}
                        alt="Vessel"
                        className="engraving-approval-img"
                        style={{ width: '100%' }}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <div style={{ height: '25px' }}>&nbsp;</div>
                </Col>
            </Row>
        </div>
    );
}

export default EngravingImages;
